<template>
  <v-container class="pa-6">
    <v-row align="center">
      <v-col cols="auto" class="pr-0">
        <v-btn
          to="/alerts"
          icon
          outlined
          color="hsl(0, 0%, 59%)"
          style="background-color: hsl(0, 0%, 94%)"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto" class="pr-0">
        <div class="text-h5">
          <span style="font-family: Inter; text-transform: uppercase">
            Alert
          </span>
        </div>
      </v-col>
      <v-col cols="auto" class="pr-0">
        <v-chip
          color="black"
          outlined
          label
          class="mr-3"
          style="height: 36px; background-color: white !important"
        >
          {{ silencedUntilText }}
        </v-chip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" class="pl-0">
        <v-btn
          icon
          outlined
          color="hsl(0, 0%, 59%)"
          style="background-color: hsl(0, 0%, 94%)"
          @click="editAlert"
        >
          <v-icon small>mdi-bell-off</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-timeline class="mt-6" style="padding-top: 0px; padding-bottom: 0px">
      <timeline-item
        v-for="a in alerts"
        :key="a.id"
        :notification="a"
        display="alert"
      />
    </v-timeline>
  </v-container>
</template>

<script>
import TimelineItem from '../components/Notifications/TimelineItem.vue';

import { mapGetters, mapActions } from 'vuex';
import { flatten } from '../utils/flatten';

export default {
  components: {
    TimelineItem,
  },
  computed: {
    ...mapGetters({
      notifications: 'allNotificationsByTimeRaised',
    }),
    alertId() {
      return this.$route.params.alert;
    },
    alerts() {
      return this.notifications.filter(
        (alert) =>
          alert.metric == this.$route.query.metric &&
          alert.source == this.$route.query.source &&
          alert.url == this.$route.query.url
      );
    },
    alert() {
      let result = this.notifications
        ? this.notifications.filter(
            (notification) => notification.id == this.alertId
          )[0]
        : null;
      return result;
    },
    alertArchived() {
      return this.alert ? this.alert.archived : null;
    },
    alertType() {
      return this.alert ? this.alert.type : null;
    },
    alertText() {
      return this.alert ? this.alert.text : null;
    },
    alertTime() {
      return this.alert ? this.alert.time : 0;
    },
    activeNotifications() {
      return this.notifications.filter((notification) => {
        return !notification.archived;
      }).length;
    },
    successNotifications() {
      return this.notifications.filter((notification) => {
        return notification.type == 'success' && !notification.archived;
      }).length;
    },
    warningNotifications() {
      return this.notifications.filter((notification) => {
        return notification.type == 'warning' && !notification.archived;
      }).length;
    },
    errorNotifications() {
      return this.notifications.filter((notification) => {
        return notification.type == 'error' && !notification.archived;
      }).length;
    },
    isSilenced() {
      let chains = this.$store.state.chain.chains;
      let nodes = flatten(chains.map((chain) => chain.nodes));

      // Check node alerts
      let alerts = flatten(nodes.map((node) => node.alerts));
      let matchingAlerts = alerts.filter(
        (alert) =>
          alert.source_id == this.$route.query.source &&
          alert.metric == this.$route.query.metric &&
          alert.url == this.$route.query.url
      );

      // If found silenced node alert, return early
      if (matchingAlerts.length > 0) {
        return {
          isSilenced: matchingAlerts[0].is_silenced,
          silencedUntil: matchingAlerts[0].silenced_until,
        };
      }

      // Check chain alerts
      let chainAlerts = flatten(chains.map((chain) => chain.alerts));
      matchingAlerts = chainAlerts.filter(
        (alert) =>
          alert.source_id == this.$route.query.source &&
          alert.metric == this.$route.query.metric &&
          alert.url == this.$route.query.url
      );

      if (matchingAlerts.length > 0) {
        return {
          isSilenced: matchingAlerts[0].is_silenced,
          silencedUntil: matchingAlerts[0].silenced_until,
        };
      }

      // No matching alerts found
      return { isSilenced: false, silencedUntil: null };
    },
    silencedUntilText() {
      if (!this.isSilenced.isSilenced) {
        return 'Not Silenced';
      }
      if (!this.isSilenced.silencedUntil) {
        return 'Silenced';
      }
      const silencedUntil = new Date(this.isSilenced.silencedUntil);
      return `Silenced Until: ${this.toTimeHumanFormat(silencedUntil)}`;
    },
  },
  methods: {
    ...mapActions(['archiveNotifications', 'archiveAll']),
    notificationTypeColor(alert) {
      let notificationType = alert ? alert.type : null;
      let notificationArchived = alert ? alert.archived : null;
      if (notificationArchived) return 'grey';
      else if (notificationType == 'success') return 'green';
      else if (notificationType == 'error') return 'red';
      else if (notificationType == 'warning') return '#f4b236';
      else return 'grey';
    },
    getAlertType(alert) {
      return alert ? alert.type : null;
    },
    getAlertText(alert) {
      return alert ? alert.text : null;
    },
    getAlertTime(alert) {
      return alert ? alert.time : 0;
    },
    editAlert() {
      this.$emit('editAlert', {
        metric: this.$route.query.metric,
        source: this.$route.query.source,
        url: this.$route.query.url,
      });
    },
  },
};
</script>

<style>
.v-timeline-item:last-of-type {
  padding-bottom: 0px;
}
</style>
